export const imageBasePath = "https://tezbikes.com/tezbike/assets";
export const apiBasePath =
  "https://api.myad360.com/api/v1/FNV89uJ9sud/rest_api";
